import { CardSkeleton } from './skeleton'

interface RouteLoaderProps {
  label?: string
}

export default function RouteLoader({ label = 'Loading…' }: RouteLoaderProps) {
  return (
    <div role="status" aria-live="polite" className="py-4 sm:py-6 space-y-6">
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4" aria-label={label}>
        <CardSkeleton />
        <CardSkeleton />
        <CardSkeleton />
      </div>
    </div>
  )
}


